
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { VersionImplementation } from '@commoncore/implementation/VersionImplementation';
import { VersionModuleType } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { GlobalService } from '../services/global.service';
import { Controller } from './Controller';

export class VersionController extends Controller{
  public versionImplementation: any;
  public universalService: any;
  public static singleInstance: any = null;
  
  public constructor(public globalService:GlobalService) {
    super(globalService);
    this.versionImplementation = VersionImplementation.getInstance(globalService);
    this.versionImplementation.setHandler(this.globalService)
    this.setEnvObjects(globalService);
  }

  public static getInstance(globalService): VersionController {
    if (this.singleInstance == null) {
      this.singleInstance = new VersionController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
  }


  async getVersionsForFile(moduleType,requiredMetadataForVersioningAPI){
    var url = await this.getVersionListURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI);
    this.versionImplementation.setHandler(this.globalService);
    try{
    var result = await this.versionImplementation.getVersionsForFile(url);
    return result;
    }catch(err){
    console.log("expception in fetching version list",err);
    return err;
    }
  }


  async deleteSelectedVersion(moduleType,requiredMetadataForVersioningAPI,selectedVersionToDelete){
    var url = await this.getDeleteVersionURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI);
    this.versionImplementation.setHandler(this.globalService);
    try{
    var result = await this.versionImplementation.deleteSelectedVersionOfTheFile(url,requiredMetadataForVersioningAPI,selectedVersionToDelete);
    return result;
    }catch(err){
    console.log("expception in deleting selected version",err);
    return err;
    }
  }

  async restoreSelectedVersion(moduleType,requiredMetadataForVersioningAPI,selectedVersionToDelete){
    var url = await this.getRestoreVersionURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI);
    this.versionImplementation.setHandler(this.globalService);
    try{
    var result = await this.versionImplementation.restoreSelectedVersionOfTheFile(url,requiredMetadataForVersioningAPI,selectedVersionToDelete);
    return result;
    }catch(err){
    console.log("expception in restoring selected version",err);
    return err;
    }
  }

  async getVersionListURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI){
    var url = "";
    switch(moduleType){
        case VersionModuleType.MY_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + '/' + requiredMetadataForVersioningAPI["objectKey"];
            return url;
        case VersionModuleType.ALBUMS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + '/' + requiredMetadataForVersioningAPI["objectKey"] + "?boardKey=" + requiredMetadataForVersioningAPI["boardKey"];
            return url;
        case VersionModuleType.SHARED_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + '/' + requiredMetadataForVersioningAPI["objectKey"] + "?shareKey=" + requiredMetadataForVersioningAPI["shareKey"];
            return url;
        case VersionModuleType.TEAM_FOLDERS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + '/' + requiredMetadataForVersioningAPI["objectKey"] + "?tfKey=" + requiredMetadataForVersioningAPI["tfKey"];
            return url;
        default:
            console.log("versioning does not exist for given module type",moduleType);
            return "invalid module"
    }
  }

  async getDeleteVersionURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI){
    var url = "";
    switch(moduleType){
        case VersionModuleType.MY_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["deleteforever"];
            return url;
        case VersionModuleType.ALBUMS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["deleteforever"] + "?boardKey=" + requiredMetadataForVersioningAPI["boardKey"];
            return url;
        case VersionModuleType.SHARED_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["deleteforever"] + "?shareKey=" + requiredMetadataForVersioningAPI["shareKey"];
            return url;
        case VersionModuleType.TEAM_FOLDERS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["deleteforever"] + "?tfKey=" + requiredMetadataForVersioningAPI["tfKey"];
            return url;
        default:
            console.log("versioning does not exist for given module type",moduleType);
            return "invalid module"
    }
  }

  async getRestoreVersionURLBasedOnModule(moduleType,requiredMetadataForVersioningAPI){
    var url = "";
    switch(moduleType){
        case VersionModuleType.MY_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["restore"];
            return url;
        case VersionModuleType.ALBUMS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["restore"] + "?boardKey=" + requiredMetadataForVersioningAPI["boardKey"];
            return url;
        case VersionModuleType.SHARED_FILES:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["restore"] + "?shareKey=" + requiredMetadataForVersioningAPI["shareKey"];
            return url;
        case VersionModuleType.TEAM_FOLDERS:
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["manageVersions"] + ENV_CONFIG["commonUrls"]["restore"] + "?tfKey=" + requiredMetadataForVersioningAPI["tfKey"];
            return url;
        default:
            console.log("versioning does not exist for given module type",moduleType);
            return "invalid module"
    }
  }
}